module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 pointer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "submit",
      "id": _vm.id,
      "disabled": _vm.loading
    }
  }, [(!_vm.loading) ? _c('span', [_vm._t("default", function() {
    return [_vm._v("Submit")]
  })], 2) : _c('span', [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39d1ba76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/buttons/SubmitButton.vue
// module id = 655
// module chunks = 5